import { all } from 'redux-saga/effects';

import { rootSaga as user } from './user/sagas';

export function* rootSaga() {
  yield all([user()]);
}
